import { Col, Row } from 'antd';
import type { User } from 'api/models/mainservice';
import type { Codebook } from 'common/models';
import { Box, PageHeading } from 'components';
import { useCustomTranslation } from 'helpers/translationHelper';

import type { DashboardData } from '../models';
import BarChart from './BarChart';
import PieChart from './PieChart';

interface OwnProps {
  data?: DashboardData;
  isLoading: boolean;
  users: User[];
  orderCategories: Codebook[];
}

const StatisticsCharts = (props: OwnProps) => {
  const { t } = useCustomTranslation();

  if (!props.data) return null;

  return (
    <>
      <PageHeading title={t('dashboard:heading')} />
      <Row gutter={16}>
        <Col md={24} lg={12}>
          <Box>
            <BarChart
              users={props.users}
              orderCategories={props.orderCategories}
              data={props.data}
            />
          </Box>
        </Col>
        <Col md={24} lg={12}>
          <Box>
            <PieChart orderCategories={props.orderCategories} data={props.data} />
          </Box>
        </Col>
      </Row>
    </>
  );
};

export default StatisticsCharts;
